import LoadingScreen from '@webstollen/react-native/lib/components/LoadingScreen'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { useRouteMatch } from '@webstollen/react-native/lib/react-router'
import { SemVer } from 'semver'
import useStyles from './styles'
import LiveTrackerV1 from './v1'
import { SessionContext } from '../../../../context/SessionContext'

const LiveTracker = () => {
  const styles = useStyles()

  const { t } = useTranslation()

  const match = useRouteMatch<{ shopId: string }>()

  const { shopId } = match.params

  const { shops } = useContext(SessionContext)
  const shop = shops && shops[shopId]

  if (!shop) {
    return <LoadingScreen text={t('loading.shop')} />
  }

  const version = new SemVer(shop.platform.sdkVersion)

  switch (version.major) {
    case 1:
      return <LiveTrackerV1 shop={shop} />
    default:
      return (
        <View style={styles.wrapper}>
          <View style={styles.container}></View>
        </View>
      )
  }
}

export default LiveTracker
